import * as React from "react"

import {BACKEND_APIS} from "@constants"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core";

import { sectionCategory, retailer, country } from "@signals"


export default function SectionCategoryAutocompleteAjax({ filters = {}, ...props }) {

    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/section-category/wrapped/new-options`}
        filters={{ retailer: retailer.value, ...filters }}
        label="Section"
        placeholder="All Sections"
        value={sectionCategory.value}
        onChange={e => sectionCategory.value = e.target.value}
        {...props}
    />
}
